import { render, staticRenderFns } from "./editAddress.vue?vue&type=template&id=bdbb2f80&scoped=true&"
import script from "./editAddress.vue?vue&type=script&lang=js&"
export * from "./editAddress.vue?vue&type=script&lang=js&"
import style0 from "./editAddress.vue?vue&type=style&index=0&id=bdbb2f80&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdbb2f80",
  null
  
)

export default component.exports